import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyEmail as verifyEmailAction, useAppDispatch } from '../redux';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasVerified = useRef(false); // Prevents double execution

  const emailVerification = async () => {
    const token = searchParams.get('token');

    if (!token) {
      setError('Invalid verification link');
      setLoading(false);
      return;
    }

    try {
      await dispatch(verifyEmailAction(token));
      
      // Push Google Ads event for email verification success (signup qualified lead)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'email_verified'
      });
      
      navigate('/login');
    } catch (error) {
      setError('Failed to verify email. Please try again.');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!hasVerified.current) {
      hasVerified.current = true;
      emailVerification();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid auth-container" style={{ minHeight: 'calc(100vh - 200px)', paddingTop: '10rem', paddingBottom: '8rem' }}>
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
          <div className="card p-4 shadow-lg" style={{ width: '100%', maxWidth: '400px' }}>
            <h3 className="text-center mb-4">Email Verification</h3>

            {loading && (
              <div className="text-center">
                <div className="spinner-border text-primary mb-3" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p>Verifying your email...</p>
              </div>
            )}

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            {!loading && !error && (
              <div className="alert alert-success" role="alert">
                Email verified successfully! Redirecting to login...
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default VerifyEmail;
